"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockNotFoundError = void 0;
const base_js_1 = require("./base.js");
class BlockNotFoundError extends base_js_1.BaseError {
  constructor(_ref) {
    let {
      blockHash,
      blockNumber
    } = _ref;
    let identifier = 'Block';
    if (blockHash) identifier = "Block at hash \"".concat(blockHash, "\"");
    if (blockNumber) identifier = "Block at number \"".concat(blockNumber, "\"");
    super("".concat(identifier, " could not be found."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'BlockNotFoundError'
    });
  }
}
exports.BlockNotFoundError = BlockNotFoundError;
//# sourceMappingURL=block.js.map